import React from 'react';
import block from 'bem-cn';

import Input from 'components/Input';
import Button from 'components/Button';

import formateNumber from 'shared/helpers/formateNumber';
import { MAX_PAYMENT_AMOUNT, sanitizePaymentAmountInput } from 'features/finance/data';

import './AmountStep.scss';

const b = block('payments-amount');

const AmountStep = ({
  amount,
  onAmountChange,
  onSubmit,
  locale,
  maxDeposit = MAX_PAYMENT_AMOUNT,
  isProcessing = false,
}) => {
  const amountNumber = Number(amount);
  const isOverLimit = amount !== '' && amountNumber > maxDeposit;
  const isSubmitDisabled = amount === '' || amountNumber <= 0 || isOverLimit || isProcessing;
  const formattedMaxDeposit = formateNumber(maxDeposit, true);

  const handleChange = event => {
    onAmountChange(sanitizePaymentAmountInput(event.target.value));
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (isSubmitDisabled) return;
    onSubmit();
  };

  return (
    <form className={b()} onSubmit={handleSubmit}>
      <h1 className={b('title')}>{locale.buyBalance}</h1>

      <div className={b('field')}>
        <label className={b('label')} htmlFor="payment-amount">
          {locale.paymentAmountUsdt}
        </label>
        <Input
          id="payment-amount"
          value={amount}
          onChange={handleChange}
          placeholder={locale.enterAmountUsdt}
          size="high"
          inputMode="decimal"
          autoComplete="off"
          validState={isOverLimit ? 3 : 1}
        />
        <p className={b('hint')}>{locale.maxAmountUsdt.replace('{amount}', formattedMaxDeposit)}</p>
      </div>

      <Button type="submit" text={locale.depositBalance} size="high" upperCased disabled={isSubmitDisabled} />
    </form>
  );
};

export default AmountStep;
